<template>
  <div class="card-footer">
    <div class="card-button-container">
      <template v-if="company.plan !== PartnerPlanTypes.BASIC">
        <a
          :id="`business-card-${index}-call-button`"
          v-track-click="{ metadata: getClickMetadata('phone') }"
          :href="`tel:${company.phone}`"
          target="_blank"
          class="w-full t-btn t-btn--medium card-footer-button"
        >
          <t-icon
            class="card-footer-button-icon mr-3"
            height="20"
            width="20"
            :icon="mdiPhoneOutline"
          />
          {{ $t('call-now') }}
        </a>
      </template>

      <a
        :id="`business-card-${index}-email-button`"
        v-track-click="{ metadata: getClickMetadata('email') }"
        :href="`mailto:${company.email}`"
        target="_blank"
        class="w-full t-btn t-btn--medium card-footer-button"
      >
        <t-icon
          class="card-footer-button-icon mr-3"
          height="20"
          width="20"
          :icon="mdiEmailOpenOutline"
        />
        {{ $t('email') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mdiEmailOpenOutline, mdiPhoneOutline } from '@mdi/js'
import usesPartnerPlan, {
  PartnerPlanTypes,
} from 'chimera/all/mixins/usesPartnerPlan'

export default {
  name: 'CardFooter',

  mixins: [usesPartnerPlan],

  props: {
    index: {
      type: Number,
      required: true,
    },

    company: {
      type: Object,
      required: true,
    },

    getClickMetadata: {
      type: Function,
      required: true,
    },
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      PartnerPlanTypes,
      mdiPhoneOutline,
      mdiEmailOpenOutline,
    }
  },
}
</script>

<i18n>
{
  "nl": {
    "call-now": "Nu bellen",
    "email": "E-mail"
  },
  "nl-BE": {
    "call-now": "Nu bellen",
    "email": "E-mail"
  },
  "es-ES": {
    "call-now": "Llamar ahora",
    "email": "Correo electrónico"
  },
  "de-DE": {
    "call-now": "Jetzt anrufen",
    "email": "E-Mail"
  },
  "fr-BE": {
    "call-now": "Appeler maintenant",
    "email": "E-mail"
  },
  "fr-FR": {
    "call-now": "Appeler maintenant",
    "email": "E-mail"
  },
  "it-IT": {
    "call-now": "Chiama ora",
    "email": "E-mail"
  }
}
</i18n>
